import './LastSeenIndicator.scss';

type LastSeenTier = 'recent' | 'moderate' | 'stale';

function getTierFromDate(date: string | null | undefined): LastSeenTier | null {
  if (!date) return null;

  try {
    const now = new Date();
    const dateObj = new Date(date);

    // Calculate threshold dates using setMonth (same as backend)
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(now.getMonth() - 6);
    const twelveMonthsAgo = new Date();
    twelveMonthsAgo.setMonth(now.getMonth() - 12);

    if (dateObj >= sixMonthsAgo) return 'recent';      // 0-6 months: green
    if (dateObj >= twelveMonthsAgo) return 'moderate'; // 6-12 months: yellow
    return 'stale';                                    // 12+ months: orange
  } catch {
    return null;
  }
}

function getTooltipText(tier: LastSeenTier, date: string): string {
  const dateObj = new Date(date);
  const formattedDate = dateObj.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
  });

  switch (tier) {
    case 'recent':
      return `Last seen ${formattedDate}`;
    case 'moderate':
      return `Last seen ${formattedDate}`;
    case 'stale':
      return `Last seen ${formattedDate}`;
  }
}

interface LastSeenIndicatorProps {
  lastSeenAt: string | null | undefined;
}

export function LastSeenIndicator({ lastSeenAt }: LastSeenIndicatorProps) {
  const tier = getTierFromDate(lastSeenAt);

  if (!tier || !lastSeenAt) {
    return (
      <div
        className="last-seen-indicator last-seen-indicator--empty"
        data-tooltip-id="main-tooltip"
        data-tooltip-content="No sighting data"
        data-tooltip-delay-hide={0}
      />
    );
  }

  return (
    <div
      className={`last-seen-indicator last-seen-indicator--${tier}`}
      data-tooltip-id="main-tooltip"
      data-tooltip-content={getTooltipText(tier, lastSeenAt)}
      data-tooltip-delay-hide={0}
    />
  );
}
